(($) => {
	"use strict";

	$(document).ready(() => {          // fires before images finish loading
		const $hero = $(".hero-background__image").first();
		if (!$hero.length) return;

		// Build timeline from the values already set in CSS
		gsap.timeline({ defaults: { ease: "power3.out" } })

		// bg image zoom & fade
		.to($hero, {
			duration: .6,
			scale: 1,          // CSS was 1.08
			opacity: 1
		})

		// headline cascade
		.to(".hero-area__headline", {
			duration: 1.5,
			y: 0,              // CSS was +40
			opacity: 1,
			stagger: 0.25
		}, "-=0.8");           // overlap a bit
	});
})(jQuery);
